type ListingType = 'map' | 'list' | 'map_area';

export function listingType(isPin: boolean, isCurrentArea: boolean): ListingType {
  if (isPin) {
    return 'map';
  }
  if (isCurrentArea) {
    return 'map_area';
  }

  return 'list';
}
